const state = {
    menuType: [
        { key: 'ROOT', val: '根节点' },
        { key: 'MENU-1', val: '一级菜单' },
        { key: 'MENU-2', val: '二级菜单' },
        { key: 'PAGE', val: '页面' },
        { key: 'BUTTON', val: '按钮' }
    ],
    isOrNo: [
        { key: true, val: '是' },
        { key: false, val: '否' }
    ],
    genderMap: [
        { key: 1, val: '男' },
        { key: 0, val: '女' }
    ],
    normalStatus: [
        { key: 0, val: '正常' },
        { key: 1, val: '禁用' },
        { key: -1, val: '删除' }
    ],
    lineStatus: [
        { key: 0, val: '正常' },
        { key: 1, val: '禁用' },
        { key: -1, val: '删除' },
        { key: 2, val: '锁定' }
    ],
    orderStatus: [
        { key: 0, val: '已付款未签合同' },
        { key: 1, val: '已付款已签合同' },
        { key: 2, val: '未付款已签合同' },
        { key: 3, val: '未付款未签合同' },
        { key: -1, val: '删除' },
        { key: -2, val: '取消订单' },
    ],
    orderType: [
        { key: 0, val: 'warning' },
        { key: 1, val: 'success' },
        { key: 2, val: 'warning' },
        { key: 3, val: 'warning' },
        { key: -1, val: 'danger' },
        { key: -2, val: 'info' },
    ],
    actionMap: {
        "enable": 0,
        "disable": 1,
        "delete": -1
    },
    ticketStatus: [
        { key: 0, val: '已组团' },
        { key: 1, val: '未组团' },
        { key: -1, val: '删除' },
    ],
    statusType: [
        { key: 0, val: 'success' },
        { key: 1, val: 'warning' },
        { key: 2, val: 'danger' },
        { key: 3, val: 'info' }
    ],
    statusType1: [
        { key: 0, val: 'success' },
        { key: 1, val: 'warning' },
        { key: 2, val: 'danger' },
        { key: -1, val: 'info' }
    ],
    pointTypes: ["购物点", "自由安排", "景区/景点", "娱乐项目"],
    tripStatus: [
        { key: 0, val: '正常' },
        { key: 1, val: '禁用' },
        { key: 2, val: '已在行程中' },
        { key: -1, val: '删除' },
    ],
    tripShowStatus: [
        { key: 0, val: '正常' },
        { key: 1, val: '禁用' },
        { key: -1, val: '删除' },
    ],
    guideStatus:[
        // { key:0,val:'待绑定'},
        { key:1,val:'已绑定'},
        // { key:2,val:'取消绑定'},
        { key:3,val:'解除绑定'}
    ],
    guideType:[
        // { key: 0, val: 'warning' },
        { key: 1, val: 'success' },
        // { key: 2, val: 'danger' },
        { key: 3, val: 'info' }
    ],
};
const getters = {

};
const mutations = {

};
const actions = {
    // login({ commit }, param) {
    //     USER.login(param).then(res => {
    //         commit("SET_USERNAME",res.name);
    //         console.log(res);
    //     }).catch(err => {
    //         console.log(err);
    //     });
    // }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}